export default __webpack_public_path__ + "static/media/a1.205a6f45.svg";